export enum ChartSize {
  SMALL = 'sm',
  MEDIUM = 'md',
  LARGE = 'lg',
}
